module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-copy-2-9cfd42df74df11c8b69f5e4748cc82cd.svg";